import { Injectable, Inject } from '@angular/core';
import { Observable, of, shareReplay } from 'rxjs';
import { ApiService } from './api.service';
import { LookupKey } from '../../shared/constants/lookup-keys';
import { API_ENDPOINTS } from './api-endpoints.token';
import { ApiRoot } from '../../shared/constants/api-endpoints';

@Injectable({ providedIn: 'root' })
export class LookupService {
    private cache = new Map<LookupKey, Observable<any>>();
    lang: string = "ENU";
    requestBody: any = {
        "body": {
            "Type": "",
            "ProcessName": "",
            "LanguageCode": "",
            "ParentValue": ""
        }
    }
    // This method is used to initialize the class instance using api and ep
    constructor(
        private api: ApiService,
        @Inject(API_ENDPOINTS) private ep: any            // typed as needed
    ) {
        if (localStorage.getItem("selectedLang")) {
            this.lang = localStorage.getItem("selectedLang") == 'ar' ? 'ARA' : 'ENU'; //ARA
        }
    }

    /**
     * Returns shared observable for the given lookup.
     * First call hits the network, later calls reuse the cached stream.
     */
    // This method is used to get using key
    get<T = unknown>(key: LookupKey): Observable<T[]> {
        if (!this.cache.has(key)) {
            const url = this.ep.lookup[key];
            const stream$ = this.api.get<T[]>('', url).pipe(shareReplay(1));
            this.cache.set(key, stream$);
        }
        return this.cache.get(key)!;
    }
    // This method is used to post using key and params
    post<T = unknown>(key: LookupKey, params: any): Observable<T> {
        // if ParentValue is object → return empty array (or empty object)
        if (params?.ParentValue && typeof params?.ParentValue === 'object') {
            return of([] as unknown as T); // return empty result observable
        }

        // Include language also in cacheKey
        const cacheKey: any = `${key}_${params.Type}_${params.ParentValue || ''}_${this.lang}`;

        // Reuse cached stream if available
        if (this.cache.has(cacheKey)) {
            return this.cache.get(cacheKey)!;
        }

        // if (!this.cache.has(cacheKey)) {
        const url = this.ep.lookup[key];
        this.requestBody.body.ProcessName = params.ProcessName;
        this.requestBody.body.Type = params.Type;
        this.requestBody.body.LanguageCode = this.lang;        

        if (params?.ParentValue) {
            this.requestBody.body.ParentValue = params.ParentValue;
        } else {
            this.requestBody.body.ParentValue = "";
        }
        const stream$: any = this.api.post<T[]>(ApiRoot.DCCICPIntegration, url, this.requestBody).pipe(shareReplay(1));
        this.cache.set(cacheKey, stream$);
        // }
        return this.cache.get(cacheKey)!;
    }

    //clear cache method
    // This method is used to clear cache
    clearCache(): void {
        this.cache.clear();
    }
}
